import React from "react"
import { useTranslation } from "react-i18next"
import copy from "copy-to-clipboard"

import "./CopyToClipboard.scoped.scss"

export type CopyToClipboardProps = {
	text: string
	callToAction?: string
	className?: string
}

export const CopyToClipboard: React.FC<CopyToClipboardProps> = ({
	text,
	callToAction,
	className,
}) => {
	const [isCopied, setIsCopied] = React.useState<boolean>(false)

	const { t } = useTranslation()

	const copyToClipboard = (text: string) => {
		copy(text.toString())
		setIsCopied(true)
		setTimeout(() => {
			setIsCopied(false)
		}, 2000)
	}

	return (
		<button
			type="button"
			className={`c-copy-to-clipboard ${className} ${isCopied ? "is-copied" : ""}`}
			onClick={() => copyToClipboard(text)}
			style={{ animationDuration: "0.5s", animationDelay: "0" }}
			aria-label={t("copyToClipboard.copy")}
		>
			<div className="c-copy-to-clipboard__label" aria-live="polite">
				<p>{callToAction || text}</p>
			</div>
			<div className="c-copy-to-clipboard__hover" aria-live="polite">
				<p>{t("copyToClipboard.copy")}</p>
			</div>
			<div className="c-copy-to-clipboard__done" aria-live="polite">
				<p>{t("copyToClipboard.copied")}</p>
			</div>
		</button>
	)
}
